"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const mobx_1 = require("mobx");
const ecommerce_1 = require("../../api/ecommerce");
const configuration_1 = __importDefault(require("../apis/configuration/shop/configuration"));
class MachineStore {
    api = new ecommerce_1.MassiveMachineApi(configuration_1.default);
    internalMassiveMachines = new Map();
    loading = false;
    constructor() {
        (0, mobx_1.makeObservable)(this, {
            internalMassiveMachines: mobx_1.observable,
            loading: mobx_1.observable,
            isLoading: mobx_1.computed,
            cutters: mobx_1.computed,
            readMassiveMachines: mobx_1.action,
        });
    }
    get isLoading() {
        return this.loading;
    }
    get cutters() {
        return Array.from(this.internalMassiveMachines.values())
            .filter((massiveMachine) => massiveMachine.type === ecommerce_1.MassiveMachineTypeEnum.Cutter)
            .sort((a, b) => {
            return ((b.installationDate?.valueOf() ?? Number.NEGATIVE_INFINITY) -
                (a.installationDate?.valueOf() ?? Number.NEGATIVE_INFINITY));
        });
    }
    readMassiveMachines() {
        if (this.loading) {
            return Promise.resolve(this.internalMassiveMachines);
        }
        this.loading = true;
        return this.api
            .readMassiveMachineList({
            associations: {
                media: { ' ': 1 },
            },
        })
            .then((0, mobx_1.action)((massiveMachines) => {
            this.internalMassiveMachines.clear();
            massiveMachines.map((massiveMachine) => {
                this.internalMassiveMachines.set(massiveMachine.id, massiveMachine);
            });
            return this.internalMassiveMachines;
        }))
            .finally((0, mobx_1.action)(() => {
            this.loading = false;
        }));
    }
}
exports.default = new MachineStore();
